import type { NodeDefinition } from '../../../types/node-definition';

/**
 * Simple Memory Sub-Node
 * 
 * This is a sub-node that provides conversation memory to AI Agent nodes.
 * It stores and retrieves chat history from the database.
 * 
 * Parameters (defined in schema.ts):
 * - memoryType: How to store history (buffer, bufferWindow, summary)
 * - maxMessages: Maximum messages to keep (for bufferWindow)
 * - sessionIdSource: Where to get session ID (auto or custom)
 * - sessionIdExpression: Custom expression for session ID
 * - includeSystemMessages: Whether to include system messages
 * - contextWindow: Maximum tokens for context
 * - advancedOptions: Show/hide advanced settings
 */
export const simpleMemoryDefinition: NodeDefinition = {
  type: 'simpleMemory',
  name: 'Simple Memory',
  category: 'ai',
  description: 'Store and retrieve conversation history for AI agents',
  icon: 'Database',
  color: 'blue',
  version: '1.0.0',
  
  // Mark as sub-node
  isSubNode: true,
  subNodeConfig: {
    category: 'memory',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one memory per AI Agent
  },
  
  group: ['ai'],
  
  // Sub-nodes don't have traditional inputs/outputs
  inputs: [],
  outputs: [],
  
  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'memory',
        label: 'Memory',
        multiple: false
      }
    ]
  },
  
  credentials: [],
  
  defaults: {
    name: 'Simple Memory',
    color: 'blue'
  }
};
